import { css } from '@emotion/react';

export default css({
  '&.dashboard-wrapper': {
    flexDirection: 'column',
    height: '100%',
    backgroundColor: '#f4f7fb',
  },
});
